module.exports = __webpack_public_path__ + "static/media/IE.cf8d5f44.svg";